import React from 'react';
import { getStatusTone } from '../status';
export function StatusBadge({ status, label, className = '', ...props }) {
  const tone = getStatusTone(status);
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${tone.className} ${className}`} {...props}>{label || tone.label}</span>;
}
